import i18n from "i18next";
import { reactI18nextModule } from "react-i18next";

import translationES from './locales/es_AR/translation.json';
import translationEN from './locales/en_US/translation.json';
import translationPT from './locales/pt_BR/translation.json';

// the translations
const resources = {
  es_AR: {
    translation: translationES
  },
  en_US: {
    translation: translationEN
  },
  pt_BR: {
    translation: translationPT
  }
};

i18n
  .use(reactI18nextModule) // passes i18n down to react-i18next
  .init({
    resources,
    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
